<template>
    <form autocomplete="off" accept-charset="UTF-8" class="filters filters--events" ref="form">
        <input type="hidden" name="scroll" value="events">
        <input type="hidden" name="view" value v-model="view">
        <div class="filter filter--buttons" :class="view">
            <button type="button" value="map" class="map" @click="setView('map')">
                Kaartweergave
            </button>
            <button type="button" value="list" class="list" @click="setView('list')">
                Lijstweergave
            </button>
        </div>
        <div class="filter filter--city">
            <input type="hidden" name="postcode" v-model="postcode">
            <input type="hidden" name="stad" v-model="stad">
            <input type="hidden" name="land" v-model="land">
            <label for="story-filter-city">Gemeente</label>
            <v-select label="label" :clearable="false" :value="city" :options="cityOptions" @search="onSearch" @input="setCity" id="story-filter-city" placeholder="Postcode en stad">
                <div slot="no-options">Typ een postcode of een stad</div>
            </v-select>
        </div>
        <div class="filters__submit">
            <input class="btn btn--green" type="submit" value="Zoek">
        </div>
    </form>
</template>

<script>
import vSelect from 'vue-select'

export default {
    props: {
        view: {
            type: String,
            default: 'map'
        }
    },
    data() {
        return {
            cityOptions: [],
            city: null,
            stad: '',
            postcode: '',
            land: ''
        }
    },
    components: {
        vSelect
    },
    methods: {
        onSearch(search, loading) {
            if(search.length >= 2) {
                loading(true);
                this.search(loading, search, this);
            }
        },
        search(loading, search, vm) {
            fetch(
                `/actions/reveil-module/cities/options?q=${escape(search)}`
            ).then(res => {
                res.json().then(json => (vm.cityOptions = json));
                loading(false);
            });
        },
        setCity(val) {
            this.city = val
            this.postcode = val !== null ? val.zipcode : ''
            this.stad = val !== null ? val.city : ''
            this.land = val !== null ? val.country : ''
        },
        setView(val) {
            this.view = val
            this.$nextTick(function () {
                this.submit()
            })
        },
        submit() {
            this.$refs.form.submit()
        }
    }
}
</script>